/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomizerModel,
  ProductCustomizerRequestModel,
  ValidationErrorResponse,
} from '../models/index';
import {
    CustomizerModelFromJSON,
    CustomizerModelToJSON,
    ProductCustomizerRequestModelFromJSON,
    ProductCustomizerRequestModelToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';
import { HandleRequest } from '../../handle-request'
export type GetProductCustomizerRequest = {
    catalog: string;
    productCustomizerRequestModel?: ProductCustomizerRequestModel;
}



/**
 * 
 */
export class ProductCustomizerApi extends runtime.BaseAPI {


    /**
     */
     getProductCustomizer = HandleRequest.Handle<GetProductCustomizerRequest,CustomizerModel>('ProductCustomizerApi_getProductCustomizer',async (requestParameters: GetProductCustomizerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomizerModel>>  => {
        if (requestParameters['catalog'] == null) {
            throw new runtime.RequiredError(
                'catalog',
                'Required parameter "catalog" was null or undefined when calling getProductCustomizer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        let response = null;


         response = await this.request({
            path: `/api/{catalog}/product/get-product-customizer`.replace(`{${"catalog"}}`, encodeURIComponent(String(requestParameters['catalog']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductCustomizerRequestModelToJSON(requestParameters['productCustomizerRequestModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomizerModelFromJSON(jsonValue));
    })

    /**
     */


}
